<template>
  <v-container id="users-tables" fluid tag="section">
    <base-material-card
      icon="mdi-clipboard-text"
      title="Chi tiết hội thoại"
      class="px-5 py-3"
    >
      <v-data-table
        :headers="headers"
        :items="messages"
        :page.sync="page"
        :loading="loading"
        loading-text="Đang tải... Vui lòng chờ"
        hide-default-footer
      >
        <template v-slot:item.user.avatar="{ item }">
          <v-avatar size="36" class="elevation-2">
            <img
              alt="Avatar"
              :src="item.user.avatar || require('@/assets/face.jpg')"
            />
          </v-avatar>
        </template>
        <template v-slot:item.createdAt="{ item }">
          {{ formatDate(item.createdAt) }}
        </template>
      </v-data-table>
      <v-pagination
        v-model="page"
        class="mt-5"
        :circle="false"
        :disabled="false"
        :length="totalPages"
        next-icon="navigate_next"
        prev-icon="navigate_before"
        :page="page"
        :total-visible="totalPages"
        @input="goToPage"
      />
    </base-material-card>
  </v-container>
</template>

<script>
import ConversationApi from "@/api/ConversationApi";
export default {
  data() {
    return {
      conversationId: "",
      headers: [
        {
          text: "",
          align: "start",
          sortable: false,
          value: "user.avatar"
        },
        { text: "Người gửi", value: "user.name" },
        { text: "Nội dung", value: "text" },
        { text: "Thời gian", value: "createdAt" }
      ],
      page: 1,
      totalPages: 0,
      messages: [],
      loading: true
    };
  },
  async mounted() {
    this.conversationId = this.$route.params.id;
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      const response = await ConversationApi.getMessages(this.$route.params.id);

      this.loading = false;
      const { ok, data, headers } = response;
      if (ok) {
        this.messages = data.messages;
        this.totalPages = parseInt(headers["x-total"], 10);
      }
    },

    formatDate(date) {
      const createdAt = new Date(date);
      return `${createdAt.toLocaleTimeString()} ${createdAt.toLocaleDateString()}`;
    },

    async goToPage(page) {
      this.page = page;
      this.loading = true;
      const response = await ConversationApi.getMessages(
        this.conversationId,
        page
      );
      this.loading = false;
      const { ok, data } = response;
      if (ok) {
        this.messages = data.messages;
      }
    }
  }
};
</script>
